export default ({ request }) => ({
  // GoodsPackageSize
  orderGoodsPackageSizeListApi(data = {}) {
    return request({
      url: '/factory/order/goods/package/size/list',
      method: 'post',
      data,
    })
  },
  orderGoodsPackageSizeDetailApi(data = {}) {
    return request({
      url: '/factory/order/goods/package/size/detail',
      method: 'post',
      data,
    })
  },
  orderGoodsPackageSizeSaveApi(data = {}) {
    return request({
      url: '/factory/order/goods/package/size/add/save',
      method: 'post',
      data,
    })
  },
  orderGoodsPackageSizeEditSaveApi(data = {}) {
    return request({
      url: '/factory/order/goods/package/size/edit/save',
      method: 'post',
      data,
    })
  },
  orderGoodsPackageSizeDelApi(data = {}) {
    return request({
      url: '/factory/order/goods/package/size/del',
      method: 'post',
      data,
    })
  },
  // GoodsPackageDoc
  orderGoodsPackageDocListApi(data = {}) {
    return request({
      url: '/factory/order/goods/package/doc/list',
      method: 'post',
      data,
    })
  },
  orderGoodsPackageDocDetailApi(data = {}) {
    return request({
      url: '/factory/order/goods/package/doc/detail',
      method: 'post',
      data,
    })
  },
  orderGoodsPackageDocBatchDelApi(data = {}) {
    return request({
      url: '/factory/order/goods/package/doc/batchDel',
      method: 'post',
      data,
    })
  },
  orderGoodsPackageDocUpdateApi(data = {}) {
    return request({
      url: '/factory/order/goods/package/doc/update',
      method: 'post',
      data,
    })
  },
  orderGoodsPackageDocBatchUploadApi(data = {}) {
    return request({
      url: '/factory/order/goods/package/doc/batchUpload',
      method: 'post',
      data,
    })
  },
  orderGoodsPackageDocGoodsListApi(data = {}) {
    return request({
      url: '/factory/order/goods/package/doc/goods/list',
      method: 'post',
      data,
    })
  },
  orderGoodsPackageDocGoodsBatchAddApi(data = {}) {
    return request({
      url: '/factory/order/goods/package/doc/goods/batchAdd',
      method: 'post',
      data,
    })
  },
  orderGoodsPackageDocGoodsBatchDelApi(data = {}) {
    return request({
      url: '/factory/order/goods/package/doc/goods/batchDel',
      method: 'post',
      data,
    })
  },
})
